import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from 'store';
import { closeModal, ModalType, selectModal } from 'store/layoutSlice';
import {
    archiveProject,
    deleteProject,
    fetchProjectTasks,
    unarchiveProject,
} from 'store/projectsThunks';

import Modal from 'layout/atoms/Modal';
import Project from 'molecules/Project/Project';
import { useEffect } from 'react';

const ProjectModal = ({ archived = false }: { archived?: boolean }) => {
    const dispatch = useDispatch<AppDispatch>();
    const modalData: ModalType | null = useSelector(selectModal);
    const projectId = modalData?.id;

    useEffect(() => {
        if (projectId) {
            dispatch(fetchProjectTasks({ projectId, archived }));
        }
    }, [dispatch, projectId]);

    const handleClose = () => {
        dispatch(closeModal());
    };

    const handleArchiveProject = () => {
        if (projectId) {
            dispatch(archiveProject(projectId))
                .then(handleClose)
                .catch(() => handleClose());
        }
    };

    const handleUnarchiveProject = () => {
        if (projectId) {
            // Close modal immediately to prevent app becoming unresponsive
            handleClose();

            // Then dispatch the unarchive action
            dispatch(unarchiveProject(projectId)).catch((error) => {
                console.error('Unarchive failed:', error);
            });
        }
    };

    const handleDeleteProject = () => {
        if (projectId) {
            dispatch(deleteProject(projectId))
                .then(handleClose)
                .catch(() => handleClose());
        }
    };

    return (
        <Modal open={true} size="l" onClose={handleClose} noStyling>
            {projectId && (
                <Project
                    key={projectId}
                    id={projectId}
                    onProjectDelete={handleDeleteProject}
                    onProjectArchive={handleArchiveProject}
                    onProjectUnarchive={handleUnarchiveProject}
                    archived={archived}
                    modal
                    addTask={modalData?.addTask || false}
                />
            )}
        </Modal>
    );
};

export default ProjectModal;
